
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CHANGE_TIMEZONE_UPDATE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { changeTimezoneUpdateResult } from 'Redux/actions';


function* updateChange({ payload }) {
    try {
        const QUERY = `
            mutation updateUnitsBatch ($unitIds: [Int]!, $features: UnitFeatureInput!, $simProviderAccountId: Int, $companyId: Int, $timezoneId: Int, $reference: String) {
                result: updateUnitsBatch (unitIds: $unitIds, features: $features, simProviderAccountId: $simProviderAccountId, companyId: $companyId, timezoneId: $timezoneId, reference: $reference){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate    
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) yield put(changeTimezoneUpdateResult({ update: data?.result }))
        else yield put(changeTimezoneUpdateResult({ update: false }))

    } catch (exc) {
        put(changeTimezoneUpdateResult({ update: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeTimezone/redux/saga",
            "updateChange",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CHANGE_TIMEZONE_UPDATE_REQUEST, updateChange);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}